var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconTickMark = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, props = __rest(_a, ["size", "className"]);
    return (_jsx("span", __assign({ className: "mex-icon mex-icon--".concat(size, " ").concat(className) }, props, { children: _jsxs("svg", __assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_1_288)" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM21.5508 11.722C21.9609 11.312 22.6257 11.312 23.0357 11.722C23.4458 12.1321 23.4458 12.7969 23.0357 13.2069L15.7172 20.5255C15.6516 20.5912 15.6187 20.624 15.5899 20.6507C15.3257 20.8949 15.012 21.055 14.683 21.1308C14.0576 21.275 13.3767 21.115 12.8745 20.6507C12.8457 20.6241 12.8129 20.5913 12.7475 20.5258L12.7473 20.5256L12.7472 20.5256L9.31778 17.096C8.90774 16.686 8.90775 16.0212 9.31779 15.6111C9.72785 15.2011 10.3927 15.2011 10.8027 15.6111L14.2322 19.0407L21.5508 11.722Z" }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_1_288" }, { children: _jsx("rect", { width: "32", height: "32", fill: "white" }) })) })] })) })));
};
export default IconTickMark;
